/**
 * GTM dataLayer helpers.
 *
 * @package     Emb_Coverage_Suite
 * @subpackage  Emb_Coverage_Suite/Public/JS
 * @since       0.1.0
 */
/**
 * Push 'add_to_cart' event to the dataLayer.
 *
 * @param {Array} items - List of items in the GA4 ecommerce item format.
 */
function emb_add_to_cart(items)
{
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'add_to_cart',
		ecommerce: {
			items: items
		}
	});
}

/**
 * Push 'begin_checkout' event to the dataLayer.
 *
 * @param {Array} items - List of items in the GA4 ecommerce item format.
 * @param {number} value - Total value of what's being contracted.
 */
function emb_begin_checkout(items, value)
{
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'begin_checkout',
		value: value,
		ecommerce: {
			items: items
		}
	});
}

/**
 * Push 'add_shipping_info' event to the dataLayer.
 *
 * @param {Array} items - List of items in the GA4 ecommerce item format.
 * @param {number} value - Total value of what's being contracted.
 */
function emb_add_shipping_info(items, value)
{
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'add_shipping_info',
		value: value,
		ecommerce: {
			items: items
		}
	});
}

/**
 * Push 'add_payment_info' event to the dataLayer.
 *
 * @param {Array} items - List of items in the GA4 ecommerce item format.
 * @param {number} value - Total value of what's being contracted.
 */
function emb_add_payment_info(items, value)
{
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'add_payment_info',
		value: value,
		ecommerce: {
			items: items
		}
	});
}

/**
 * Push 'purchase' event to the dataLayer.
 *
 * @param {Array} items - List of items in the GA4 ecommerce item format.
 * @param {number} value - Total value of the transaction.
 * @param {string} transactionId - Unique id of the transaction.
 */
function emb_purchase(items, value, transactionId)
{
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'purchase',
		ecommerce: {
			currency: 'EUR',
			value: value,
			tax: 0,
			shipping: 0,
			affiliation: '',
			transaction_id: transactionId,
			coupon: '',
			items: items
		}
	});
}
